import styled from "styled-components";
import { IStyleElement } from "~/types/types";
import breakpoints from "./breakpoints";

const A = styled.a<IStyleElement>`
  ${p => p.xsStyle}
  ${breakpoints.sm} {
    ${p => p.smStyle}
  }
  ${breakpoints.md} {
    ${p => p.mdStyle}
  }
  ${breakpoints.lg} {
    ${p => p.lgStyle}
  }
  ${breakpoints.xl} {
    ${p => p.xlStyle}
  }
`

export default A